(function () {
  "use strict";

  if (!window.DNB) {
    return;
  }

  window.DNB.register(function () {
    var slider = document.querySelector("[data-testimonials-slider]");
    if (!slider || !window.Swiper) {
      return;
    }

    var swiperOptions = {
      slidesPerView: 3.2,
      centeredSlides: true,
      spaceBetween: 32,
      speed: 6000, 
      loop: true,
      grabCursor: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false
      },
      freeMode: {
        enabled: true,
        sticky: true,
      },
      initialSlide: 1,
      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 16
        },
        640: {
          slidesPerView: 1.6,
          spaceBetween: 20
        },
        900: {
          slidesPerView: 2.2,
          spaceBetween: 24
        },
        1200: {
          slidesPerView: 3.2,
          spaceBetween: 32
        }
      }
    };

    var normalizeSlidesValue = function (value) {
      return typeof value === "number" && !isNaN(value) ? value : 1;
    };

    var getMaxSlidesPerView = function (options) {
      var maxValue = normalizeSlidesValue(options.slidesPerView);
      var breakpoints = options.breakpoints || {};
      Object.keys(breakpoints).forEach(function (key) {
        var entry = breakpoints[key];
        if (entry && typeof entry.slidesPerView !== "undefined") {
          var nextValue = normalizeSlidesValue(entry.slidesPerView);
          if (nextValue > maxValue) {
            maxValue = nextValue;
          }
        }
      });
      return maxValue;
    };

    var getMaxSlidesPerGroup = function (options) {
      var maxValue = normalizeSlidesValue(options.slidesPerGroup || 1);
      var breakpoints = options.breakpoints || {};
      Object.keys(breakpoints).forEach(function (key) {
        var entry = breakpoints[key];
        if (entry && typeof entry.slidesPerGroup !== "undefined") {
          var nextValue = normalizeSlidesValue(entry.slidesPerGroup);
          if (nextValue > maxValue) {
            maxValue = nextValue;
          }
        } 
      });
      return maxValue;
    };

    var ensureLoopSlides = function (root, options) {
      if (!root || !options || !options.loop) {
        return;
      }
      var wrapper = root.querySelector(".swiper-wrapper");
      if (!wrapper) {
        return;
      }
      var slides = Array.prototype.slice.call(wrapper.children).filter(function (slide) {
        return (
          !slide.classList.contains("swiper-slide--clone") &&
          !slide.classList.contains("swiper-slide-duplicate")
        );
      });
      if (!slides.length) {
        return;
      }
      var maxPerView = Math.ceil(getMaxSlidesPerView(options));
      var maxPerGroup = Math.ceil(getMaxSlidesPerGroup(options));
      var loopedSlides = Math.max(maxPerView, maxPerGroup);
      var required = maxPerView + loopedSlides;
      if (!required || slides.length >= required) {
        return;
      }
      var missing = required - slides.length;
      for (var i = 0; i < missing; i += 1) {
        var clone = slides[i % slides.length].cloneNode(true);
        clone.classList.add("swiper-slide--clone");
        wrapper.appendChild(clone);
      }
    };

    ensureLoopSlides(slider, swiperOptions);

    var swiper = new window.Swiper(slider, swiperOptions);

    var isHovering = false;
    var lastDirection = 1;

    var setActiveSlide = function (slide) {
      var activeSlides = slider.querySelectorAll(".swiper-slide.is-active");
      activeSlides.forEach(function (active) {
        active.classList.remove("is-active");
      });
      if (slide) {
        slide.classList.add("is-active");
      }
    };

    var pauseAutoplay = function () {
      if (swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
      }
    };

    var resumeAutoplay = function () {
      if (swiper.autoplay && !swiper.autoplay.running) {
        swiper.autoplay.start();
      }
    };

    var updateAutoplayDirection = function (direction) {
      if (!swiper.params.autoplay || direction === lastDirection) {
        return;
      }
      lastDirection = direction;
      swiper.params.autoplay.reverseDirection = direction === -1;
      if (!isHovering && swiper.autoplay && swiper.autoplay.running) {
        swiper.autoplay.stop();
        swiper.autoplay.start();
      }
    };

    var attachHoverHandlers = function () {
      var slides = Array.prototype.slice.call(slider.querySelectorAll(".swiper-slide"));
      slides.forEach(function (slide) {
        if (slide.dataset.testimonialsHoverBound === "true") {
          return;
        }
        slide.dataset.testimonialsHoverBound = "true";
        slide.addEventListener("mouseenter", function () {
          setActiveSlide(slide);
        });
        slide.addEventListener("mouseleave", function () {
          slide.classList.remove("is-active");
        });
        slide.addEventListener("focusin", function () {
          setActiveSlide(slide);
        });
        slide.addEventListener("focusout", function () {
          slide.classList.remove("is-active");
        });
      });
    };

    attachHoverHandlers();
    swiper.on("slideChangeTransitionEnd", attachHoverHandlers);

    slider.addEventListener("mouseenter", function () {
      isHovering = true;
      pauseAutoplay();
    });

    slider.addEventListener("mouseleave", function () {
      isHovering = false;
      setActiveSlide(null);
      resumeAutoplay();
    });

    if (window.gsap && window.ScrollTrigger) {
      var directionTrigger = {
        trigger: slider,
        start: "top 85%",
        end: "bottom 15%",
        invalidateOnRefresh: true,
        onUpdate: function (self) {
          updateAutoplayDirection(self.direction);
        }
      };

      if (window.DNB && window.DNB.scroller) {
        directionTrigger.scroller = window.DNB.scroller;
      }

      window.ScrollTrigger.create(directionTrigger);
    }
  });
})();
